export default __webpack_public_path__ + "static/media/add-blue.63d0466f.svg";